'use strict';

angular.module('chatEngine.mixpanel', ['chatEngine.configuration'])

.config(['$windowProvider', 'MIXPANEL_TOKEN', 'DEBUG', function($windowProvider, MIXPANEL_TOKEN, DEBUG) {
    var window = $windowProvider.$get();

    function setupMixpanel() {
        /* jshint ignore:start */
        // jscs:disable
        // mixpanel copy-paste blob
        (function(f,b){if(!b.__SV){var a,e,i,g;window.mixpanel=b;b._i=[];b.init=function(a,e,d){function f(b,h){var a=h.split(".");2==a.length&&(b=b[a[0]],h=a[1]);b[h]=function(){b.push([h].concat(Array.prototype.slice.call(arguments,0)))}}var c=b;"undefined"!==typeof d?c=b[d]=[]:d="mixpanel";c.people=c.people||[];c.toString=function(b){var a="mixpanel";"mixpanel"!==d&&(a+="."+d);b||(a+=" (stub)");return a};c.people.toString=function(){return c.toString(1)+".people (stub)"};i="disable track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config people.set people.set_once people.increment people.append people.track_charge people.clear_charges people.delete_user".split(" ");
        for(g=0;g<i.length;g++)f(c,i[g]);b._i.push([a,e,d])};b.__SV=1.2;a=f.createElement("script");a.type="text/javascript";a.async=!0;a.src="//cdn.mxpnl.com/libs/mixpanel-2.2.min.js";e=f.getElementsByTagName("script")[0];e.parentNode.insertBefore(a,e)}})(document,window.mixpanel||[]);
        // jscs:enable
        /* jshint ignore:end */
    }

    function setupMixpanelStub() {
        var mixpanel = {
            stub_data: {
                key: null,
                distinct_id: null,
                events: []
            },
            __loaded: true, // this is how angulartics tells mixpanel is ready to go
            init: function(key) {
                mixpanel.stub_data.key = key;
            },
            identify: function(distinct_id) {
                mixpanel.stub_data.distinct_id = distinct_id;
            },
            track: function(event, data) {
                mixpanel.stub_data.events.push({name: event, data: data});
            }
        };
        window.mixpanel = mixpanel;
    }

    if (!DEBUG) {
        setupMixpanel();
    } else {
        setupMixpanelStub();
    }
    window.mixpanel.init(MIXPANEL_TOKEN);
}]);
